import { defineComponent, SVGAttributes } from "vue";

  export const SvgBolt = defineComponent<SVGAttributes>({
    setup() {
      return () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13.4193,6.5002v-.01a.60156.60156,0,0,0-.5299-.31H9.6798L11.2396.7409a.57136.57136,0,0,0-.31-.6799.60321.60321,0,0,0-.7199.15L2.6607,8.8499a.591.591,0,0,0-.08.6599.60288.60288,0,0,0,.5299.32H6.3202L4.7504,15.2591a.5908.5908,0,0,0,.35.6899.41905.41905,0,0,0,.2.05h.03a.571.571,0,0,0,.4599-.21l7.5491-8.6389A.57723.57723,0,0,0,13.4193,6.5002Z"/></svg>;
    },
  });